// Others
import axiosClient from './axiosClient';
import { urlApiPriceBook } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IQueryParamBase } from '~/utils/interface/common';
import {
  IFormPriceBook,
  IPriceBook,
  IPriceBookDetail,
  IQueryUpdatePriceBook,
} from '~/utils/interface/priceBook';

const priceBookApi = {
  getPriceBookList: (params: IQueryParamBase) => {
    const url = urlApiPriceBook.getPriceBookList;
    return axiosClient.get<IBaseResponse<IListDataResponse<IPriceBook[]>>>(url, { params });
  },

  createPriceBook: (body: IFormPriceBook) => {
    const url = urlApiPriceBook.createPriceBook;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  getPriceBookDetail: (priceBookId: string) => {
    const url = urlApiPriceBook.getPriceBookDetail(priceBookId);
    return axiosClient.get<IBaseResponse<IPriceBookDetail>>(url);
  },

  updatePriceBook: ({ priceBookId, body }: IQueryUpdatePriceBook) => {
    const url = urlApiPriceBook.updatePriceBook(priceBookId);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  deletePriceBook: (priceBookId: string) => {
    const url = urlApiPriceBook.deletePriceBook(priceBookId);
    return axiosClient.delete<IBaseResponse>(url);
  },
};

export default priceBookApi;
